(function() {
  'use strict';

  // Prevents the script from running if the element is already defined
  if (customElements.get('quantity-counter')) {
    
    return;
  }

  class QuantityCounter extends HTMLElement {
    constructor() {
      super();
      
    }

    connectedCallback() {
      // Remove display:none immediately in case it was set before connection.
      this.style.removeProperty('display');

      // The theme's Popout/section JS runs after connectedCallback and re-applies
      // display:none. Use a MutationObserver to strip it whenever it appears.
      this._displayObserver = new MutationObserver(() => {
        if (this.style.display === 'none') {
          this.style.removeProperty('display');
        }
      });
      this._displayObserver.observe(this, { attributes: true, attributeFilter: ['style'] });

      this.input = this.querySelector('input');

      if (!this.input) {
        return;
      }

      this.changeEvent = new Event('change', { bubbles: true });
      this.buttonClickEvent = this.onButtonClick.bind(this);
      this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

      this.input.addEventListener('change', this.onQuantityChangeEvent);
      this.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', this.buttonClickEvent);
      });
    }

    disconnectedCallback() {
      if (this._displayObserver) {
        this._displayObserver.disconnect();
        this._displayObserver = null;
      }
    }

    onButtonClick(event) {
      event.preventDefault();

      const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');
      const step = parseInt(this.input.step, 10) || 1;
      const min = this.input.min !== '' ? parseInt(this.input.min, 10) : 1;
      const max = this.input.max !== '' ? parseInt(this.input.max, 10) : Infinity;
      const currentValue = parseInt(this.input.value, 10) || min;

      let newValue = currentValue;
      if (button.name === 'increase') {
        newValue = Math.min(currentValue + step, max);
      } else if (button.name === 'decrease') {
        newValue = Math.max(currentValue - step, min);
      }

      if (newValue !== currentValue) {
        this.input.value = String(newValue);
        this.input.setAttribute('value', String(newValue));
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    onQuantityChange() {
      
      // if (this.input.name === 'updates[]') {
      //   this.updateCart();
      // }
    }

    updateCart() {
      if (this.input.value !== '') {
        
        this.dispatchEvent(new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            id: this.input.dataset.id,
            quantity: this.input.value
          }
        }));
      }
    }
  }

  customElements.define('quantity-counter', QuantityCounter);
  

})();
